import { URL_SEPARATORS, REGEX } from "./constants";
export var isCloudinaryImageURL = function (imageURL) {
    return /res.cloudinary.com/.test(imageURL);
};
var buildTransformationPath = function (transformation) {
    return transformation.length > 0 ? transformation.join() + "/" : "";
};
var urlHasTransformations = function (url) {
    var transfRegex = new RegExp("(" + URL_SEPARATORS + ")v[0-9]+");
    return !transfRegex.test(url);
};
export var buildDensities = function (src, densities) {
    if (densities === void 0) { densities = [1, 2]; }
    var baseRegex = new RegExp("" + URL_SEPARATORS);
    var hasTransf = urlHasTransformations(src);
    var closure = hasTransf ? "," : "/";
    return densities
        .map(function (density) {
        return src.replace(baseRegex, function (match) {
            return match + "dpr_" + density + closure;
        }) + " " + density + "x";
    })
        .join(", ");
};
export var buildURL = function (url, transformations) {
    if (transformations === void 0) { transformations = []; }
    if (url) {
        var match = url.match(REGEX);
        if (match) {
            var separator = match[0];
            var urlParts = url.split(separator);
            return urlParts.length === 2
                ? "" + urlParts[0] + separator + buildTransformationPath(transformations) + urlParts[1]
                : url;
        }
    }
    return url;
};
//# sourceMappingURL=cloudinary.js.map